import { render, staticRenderFns } from "./rules-list.vue?vue&type=template&id=d848397c"
import script from "./rules-list.vue?vue&type=script&lang=js"
export * from "./rules-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports